import { AppBar, Box, IconButton, Toolbar } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import UserMenu from './UserMenu';
import AppInfoButton from './AppInfoButton';
import ReportIssueButton from './ReportIssueButton';
import DevIndicator from './DevIndicator';
import { useContext } from 'react';
import { ViewOnlyContext } from '../context';
import ViewOnlyIndicator from './ViewOnlyIndicator';
import { db } from '../instant';
import LoginButton from './LoginButton';
import { useFixedElement } from 'src/spacing';

interface Props {
    onMenuToggle: () => void;
    hideMenuToggle?: boolean;
}

export default function Navbar(props: Props) {
    const { onMenuToggle, hideMenuToggle = false } = props;
    const { isLoading, user } = db.useAuth();
    const ref = useFixedElement('top');
    const isViewOnly = useContext(ViewOnlyContext);

    const authButton = isLoading ? <></> : user ? <UserMenu /> : <LoginButton />;

    const isDev = process.env.REACT_APP_INSTANTDB_ENV === 'development';
    const maybeDevIndicator = isDev ? <DevIndicator /> : <></>;
    const maybeViewOnlyIndicator = isViewOnly ? <ViewOnlyIndicator /> : <></>;
    return (
        <>
            <AppBar ref={ref} position="fixed" sx={{ bgcolor: 'white', borderBottom: '1px solid #e0e0e0' }} elevation={0}>
                <Toolbar variant="dense">
                    {!hideMenuToggle && (
                        <IconButton onClick={onMenuToggle} aria-label="Open menu" size="large">
                            <MenuIcon />
                        </IconButton>
                    )}
                    <Box sx={{ flexGrow: 1 }} />
                    {maybeDevIndicator}
                    {maybeViewOnlyIndicator}
                    {user ? <ReportIssueButton /> : null}
                    <AppInfoButton />
                    {authButton}
                </Toolbar>
            </AppBar>
        </>
    );
}
